var map = {
	"./black/shangchuanchangjingtu.png": "FN1E",
	"./blue/shangchuanchangjingtu.png": "rXd+",
	"./white/shangchuanchangjingtu.png": "qCS3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "V7QO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/shangchuanchangjingtu\.png$
// module id = V7QO
// module chunks = 24